// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Document_wrapper__32rNc","title":"Document_title__2nwhz","name":"Document_name__1Qor5"};